import React, { useMemo, useState, useReducer, useEffect } from 'react'
import { Header, Icon, Button, Divider, Form, List, Modal } from 'semantic-ui-react'
import history from 'services/history'
import { DateTime } from 'luxon'
import request from 'services/http'
import { map, tap, finalize } from 'rxjs/operators'
import { forkJoin } from 'rxjs'
import { useSubscription } from 'utils'
import { toast } from 'react-toastify'
import ListarEventos from './ListarEventos'

const initialFormValues = {
    empresa: '',
    periodo: '',
}

function formReducer(state, action) {
    if ('reset' in action)
        return initialFormValues
    if (!('payload' in action))
        return state
    return { ...state, ...action.payload }
}

export default function ListarDigitacao() {

    const [form, setForm] = useReducer(formReducer, initialFormValues)
    const [loading, setLoading] = useState(true)
    const [listeningEvents, setListeningEvents] = useState(false)
    const [isFetchingEventos, setIsFetchingEventos] = useState(false)
    const [isPersisting, setIsPersisting] = useState(false)
    const [periodoOptions, setPeriodoOptions] = useState([])
    const [empresas, setEmpresas] = useState([])
    const [eventos, setEventos] = useState([])
    const [funcionarios, setFuncionarios] = useState([])
    const [progress, setProgress] = useState([])
    const [openModalEnviarProdac, setOpenModalEnviarProdac] = useState(false)
    const [formProdac, setFormProdac] = useReducer(formReducer, initialFormValues)
    const [listaUnidadesEnviar, setListaUnidadesEnviar] = useState([])

    const empresas$ = useMemo(() => request({
        method: 'GET',
        url: '/departamento-pessoal/empresas'
    }).pipe(
        map(({ response }) => response.empresas)
    ), [])

    const periodos$ = useMemo(() => request({
        method: 'GET',
        url: '/departamento-pessoal/periodos-utilizados'
    }).pipe(
        map(({ response }) => response.periodos)
    ), [])

    const funcionarios$ = useMemo(() => request({
        method: 'GET',
        url: '/departamento-pessoal/funcionarios'
    }).pipe(
        map(({ response }) => response.funcionarios)
    ), [])

    const fetchDados$ = useMemo(() => forkJoin({
        empresas: empresas$,
        periodos: periodos$,
        funcionarios: funcionarios$
    }).pipe(
        tap(response => {
            const options = []
            for (const p of response.periodos) {
                const date = DateTime.fromFormat(p.toString(), 'yyyyMM')
                options.push({
                    text: date.monthLong[0].toUpperCase() + date.monthLong.slice(1) + ' / ' + date.year,
                    value: date.toFormat('yyyyMM')
                })
            }
            setPeriodoOptions(options)
            setEmpresas(response.empresas)
            setFuncionarios(response.funcionarios)
        }),
        finalize(() => setLoading(false))
    ), [empresas$, periodos$, funcionarios$])

    useSubscription(fetchDados$, loading)

    const fetchEventos$ = useMemo(() => request({
        method: 'GET',
        url: '/departamento-pessoal/eventos',
        params: {
            ...form,
            funcionario: 0
        }
    }).pipe(
        tap(({ response }) => {
            // console.log(response)
            setEventos(response.eventos)
        }),
        finalize(() => setIsFetchingEventos(false))
    ), [form])

    useSubscription(fetchEventos$, isFetchingEventos && form.periodo !== "" && form.empresa !== "")

    const persistProdac$ = useMemo(() => request({
        method: 'POST',
        url: '/departamento-pessoal/persistir-prodac',
        body: { ...form, empresa: listaUnidadesEnviar },
        headers: { 'Content-Type': 'application/json' }
    }).pipe(
        // tap(response => console.log('RESP', response)),
        finalize(() => setIsPersisting(false))
    ), [form, listaUnidadesEnviar])

    useSubscription(persistProdac$, isPersisting)

    useEffect(() => {
        if (!listeningEvents) {
            const events = new EventSource(`${process.env['REACT_APP_API']}/departamento-pessoal/events`, {
                headers: { Authorization: `JWT ${localStorage.getItem('JWTANF')}` }
            })

            events.onmessage = event => setProgress(state => state.concat("<b>" + DateTime.local().toFormat("dd/MM/yyyy HH:mm:ss") + "</b> - " + event.data))
            events.onerror = event => event.preventDefault()

            setListeningEvents(true)
        }

    }, [listeningEvents])

    function handleChange(_, { name, value }) {
        setForm({ payload: { [name]: value } })
        setIsFetchingEventos(true)
    }

    function handleChangeProdac(_, { name, value }) {
        setFormProdac({ payload: { [name]: value } })
        if (!listaUnidadesEnviar.find(it => it === value))
            setListaUnidadesEnviar([...listaUnidadesEnviar].concat(value))
    }

    function submitToProdac() {
        console.log(listaUnidadesEnviar)
        if (!(!!listaUnidadesEnviar) || !(!!form.periodo))
            toast.error('Por favor, escolha o periodo e a empresa antes de enviar.')
        else {
            setIsPersisting(true)
            setOpenModalEnviarProdac(false)
        }
    }

    const removeUnidade = (index) => {
        let aux = [...listaUnidadesEnviar]
        aux.splice(index, 1)
        setListaUnidadesEnviar(aux)
    }

    const dadosProps = { eventos, funcionarios, form }

    return (
        <div className="row flex-grow-1 mt-2">
            <div className="col d-flex flex-column">
                <div className="row mx-0">
                    <div className="col px-0">
                        <Header as='h3'>
                            <Icon.Group size='big'>
                                <Icon name='list alternate' className='primary-color' />
                            </Icon.Group>
                            <Header.Content className='primary-color'>
                                Departamento Pessoal <Header.Subheader className='secondary-color'>Listar Digitações</Header.Subheader>
                            </Header.Content>
                        </Header>
                    </div>
                    <div className='col-12 col-md-4 d-print-none px-0'>
                        <Button icon size='tiny' className='btn-red' floated='right' onClick={() => history.goBack()} disabled={!!progress.length}>
                            <Icon name='arrow left' /> Voltar
                        </Button>
                        <Button icon size='tiny' color='green' floated='right' onClick={() => setOpenModalEnviarProdac(true)} disabled={!!progress.length}>
                            <Icon name='send' /> Enviar Prodac
                        </Button>
                    </div>
                </div>

                <Divider className='mt-2 custom-divider darken' fitted />

                <div className="row mx-0 mt-2">

                    <div className="col">

                        <Form size='tiny' loading={!!progress.length}>
                            <Form.Group>
                                <Form.Select
                                    width='3'
                                    required
                                    options={periodoOptions}
                                    label='Período'
                                    search
                                    selectOnBlur={false}
                                    placeholder='Selecionar Período'
                                    name='periodo'
                                    value={form.periodo}
                                    onChange={handleChange}
                                />

                                <Form.Select
                                    width='6'
                                    disabled={loading || form.periodo === ''}
                                    search
                                    noResultsMessage='Nenhum resultado encontrado'
                                    required
                                    label='Empresa'
                                    placeholder={loading === true ? 'Carregando...' : 'Selecionar Empresa'}
                                    name='empresa'
                                    selectOnBlur={false}
                                    value={form.empresa}
                                    onChange={handleChange}
                                    options={empresas.map(x => ({ key: x.id_dpnet, text: x.id + ' - ' + x.nome, value: x.id }))}
                                />
                            </Form.Group>
                        </Form>

                    </div>

                </div>

                <Divider className='mt-2 custom-divider darken' fitted />

                {progress.length === 0 && <ListarEventos {...dadosProps} /> }

                {progress.length > 0 && <>
                    <h3>Progresso do envio:</h3>
                    <List>
                        {progress.map((el, idx) => <List.Item key={idx}><span dangerouslySetInnerHTML={{ __html: el }} /></List.Item>)}
                    </List>
                </>}

                <Modal size={'tiny'} open={openModalEnviarProdac} onClose={() => { setOpenModalEnviarProdac(false) }}>
                    <Modal.Header>Enviar Prodac</Modal.Header>
                    <Modal.Content style={{ minHeight: '300px' }}>
                        <Form size='tiny'>
                            <Form.Select
                                search
                                noResultsMessage='Nenhum resultado encontrado'
                                required
                                label='Empresa'
                                placeholder={loading === true ? 'Carregando...' : 'Selecionar Empresa'}
                                name='empresa'
                                selectOnBlur={false}
                                value={formProdac.empresa}
                                onChange={handleChangeProdac}
                                options={empresas.map(x => ({ key: x.id_dpnet, text: x.id + ' - ' + x.nome, value: x.id }))}
                            />
                        </Form>
                        <List divided verticalAlign='middle'>
                            {empresas.filter(it => listaUnidadesEnviar.includes(it.id)).map((dados, index) => (
                                <List.Item key={index} style={{ padding: '10px' }}>
                                    <List.Content floated='right'>
                                        <Icon name='close' link onClick={() => removeUnidade(index)} />
                                    </List.Content>
                                    <List.Content>{dados.id} - {dados.nome}
                                    </List.Content>
                                </List.Item>
                            ))}
                        </List>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative floated='left' icon='close' onClick={() => setOpenModalEnviarProdac(false)} />
                        <Button
                            positive
                            icon='send'
                            labelPosition='left'
                            content='Enviar Prodac'
                            onClick={submitToProdac}
                        />
                    </Modal.Actions>
                </Modal>

            </div>
        </div>
    )
}
